import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import React, { useEffect, useState, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { FilterProps } from './FilterHelper';

export const ReviewedTabFilter: React.FC<FilterProps> = ({
  contacts,
  setFilteredContacts,
  sortDirection,
  sortColumn,
  sourcePage,
  setCurPage,
  contactReviewId,
}: FilterProps): React.ReactElement => {
  const intl = useIntl();
  const [selectedContactId, setSelectedContactId] = useState(
    contactReviewId || ''
  );

  const filteredContacts = useMemo(() => {
    if (selectedContactId) {
      return contacts.filter(c =>
        c.contactID.toLowerCase().includes(selectedContactId.toLowerCase())
      );
    }
    return contacts;
  }, [contacts, selectedContactId, sortColumn, sortDirection]);

  useEffect(() => {
    if (selectedContactId && setCurPage !== undefined) {
      setCurPage(1);
    }
    setFilteredContacts(filteredContacts);
  }, [filteredContacts, setCurPage, selectedContactId]);

  return (
    <Row width='100%'>
      <Input
        type='text'
        placeholder={intl.formatMessage({
          id: 'cs_perfportal_contact_recom_searchContactId',
          defaultMessage: 'Search for Contact ID',
        })}
        value={selectedContactId}
        onChange={setSelectedContactId}
        width='200px'
        data-csa-c-tag1={sourcePage || ''}
        data-csa-c-tag2='Contact Table'
        data-csa-c-tag3='REVIEWED'
        data-csa-c-type='element'
        data-csa-c-slot-id='contact-table-cr-reviewed-tab-search-slot'
        data-csa-c-content-id='contact-table-cr-reviewed-tab-search-field'
        data-csa-c-selected-value={selectedContactId}
      />
    </Row>
  );
};
